import React, {Component} from 'react'

import './Layout/BreederResultBox.css'
import BreederViewer from '../Common/BreederViewer/BreederViewer'
import SwipeSlider from '../Common/SwipeSlider/SwipeSlider'

class BreederResults extends Component {
  render () {
    const { breeders } = this.props
    return (
      <div id="BreederBoxResult">
        <SwipeSlider>
          {breeders.map((item, index) => (
            <BreederViewer key={index} breeder={item} />
            ))}
        </SwipeSlider>
      </div>
    )
  }
}

BreederResults.propTypes = {
  breeders: React.PropTypes.array
}

export default BreederResults



// WEBPACK FOOTER //
// ./src/components/SearchResult/BreederResults.js